import { render, staticRenderFns } from "./OSChar.vue?vue&type=template&id=abcc7b22&scoped=true"
import script from "./OSChar.vue?vue&type=script&lang=js"
export * from "./OSChar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abcc7b22",
  null
  
)

export default component.exports